module.exports = __webpack_public_path__ + "static/img/12areaB_06.cd531ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_06.png
// module id = 1107
// module chunks = 1